import React from 'react'
import { EarthText } from '../../../components';

export default () => (
  <div className='h-100 w-100 comment-box' align='center'>
    <i className="material-icons">notifications</i>
    <EarthText>Feature currently unavailable</EarthText>
  </div>
)
